import React from 'react';
import { Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import DialogTitle from '@mui/material/DialogTitle';
import CloseButton from 'components/common/Buttons/CloseButton';

type Props = {
  text: string;
  onClose: () => void;
  hideCloseButton?: boolean;
  endAdornment?: JSX.Element;
  className?: string;
};

const BaseModalTitle: React.FC<Props> = ({ text = '', onClose, hideCloseButton, endAdornment }) => {
  const classes = useStyles();

  return (
    <DialogTitle className={`${classes.baseTitleClass}`}>
      <Typography component="span" variant="h2">
        {text}
      </Typography>
      {!hideCloseButton && (
        <div className={classes.rightButtons}>
          <CloseButton onClick={onClose} color={'white'} margin={'unset'} />
        </div>
      )}
      {endAdornment}
    </DialogTitle>
  );
};

const useStyles = makeStyles((theme: any) => ({
  baseTitleClass: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingTop: theme.spacing(2),
    paddingLeft: theme.spacing(4),
    paddingBottom: theme.spacing(2),
    paddingRight: theme.spacing(4),
    backgroundColor: theme.palette.primary.main,
    color: 'white',
  },
  rightButtons: {
    height: '100%',
    width: '60px',
    display: 'flex',
    justifyContent: 'flex-end',
    marginRight: theme.spacing(-4),
    '& .MuiButtonBase-root': {
      color: 'white',
    },
  },
}));

export default BaseModalTitle;
